var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 6.12494C1.75 5.31952 2.40293 4.6666 3.20834 4.6666H7.875C8.68042 4.6666 9.33334 5.31952 9.33334 6.12494V10.7916C9.33334 11.597 8.68042 12.2499 7.875 12.2499H3.20834C2.40293 12.2499 1.75 11.597 1.75 10.7916V6.12494ZM3.20834 5.24994C2.72508 5.24994 2.33334 5.64167 2.33334 6.12494V10.7916C2.33334 11.2748 2.72508 11.6666 3.20834 11.6666H7.875C8.35824 11.6666 8.75 11.2748 8.75 10.7916V6.12494C8.75 5.64167 8.35824 5.24994 7.875 5.24994H3.20834Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66699 3.20834C4.66699 2.40293 5.3199 1.75 6.12531 1.75H10.792C11.5974 1.75 12.2503 2.40293 12.2503 3.20834V7.875C12.2503 8.68042 11.5974 9.33334 10.792 9.33334H10.6125C10.4514 9.33334 10.3208 9.20275 10.3208 9.04166C10.3208 8.88059 10.4514 8.75 10.6125 8.75H10.792C11.2752 8.75 11.667 8.35824 11.667 7.875V3.20834C11.667 2.72508 11.2752 2.33334 10.792 2.33334H6.12531C5.64207 2.33334 5.25031 2.72508 5.25031 3.20834V3.38783C5.25031 3.54891 5.11974 3.67948 4.95865 3.67948C4.79756 3.67948 4.66699 3.54891 4.66699 3.38783V3.20834Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.ebbd5a137e053d18a3fa0b92a3550dc4.svg";
export { ForwardRef as ReactComponent };